import {
  ModalState,
  ModalStateFactory
} from 'containers/Common/ModalStateFactory';
import {
  ModifyTrackingState,
  TrackingSummaryState
} from './TrackingManagementStates';
import { AddonFeatureManager } from 'core';
import { L1Object } from 'core/l1Object/L1Object';
import { Order } from 'core/order/Order';
import { CreateRtbCampaignSetupFlowPageModel } from 'containers/RtbCampaigns/RtbCampaignSetupFlow/RtbCampaignSetupFlowPageModel';
import { ADDONFEATURE } from 'core/agency/AddonFeature';
import { BidStrategy } from 'core/l2Object/L2Object';
import { TrackingData } from 'core/rtbCampaign/TrackingData';

export enum TrackingManagementAction {
  BatchEditTracking = 'batchEditTracking'
}

export class DefaultTrackingManagementStateFactory implements ModalStateFactory<TrackingData> {
  constructor(
    protected order: Order,
    protected l1Object: L1Object,
    protected campaigns: {
      id: number;
      name: string;
      adType: string;
      adTypeId?: number;
    }[],
    private addonFeatureManager: AddonFeatureManager
  ) {}

  async initStates(
    goModalStateFn: (
      state: ModalState,
      beforeGoState?: () => Promise<void>
    ) => void,
    closeModalFn: (dirty: boolean, beforeClose?: () => Promise<void>) => void,
    getContextData: () => TrackingData | undefined
  ) {
    // 因為不同 adType 對應的 trackingConfig 邏輯已經實作在 campaignBasicFormModel
    // 所以拿既有的 model 來初始化，之後要想一下怎麼優化這段
    const campaignCreateModel = new CreateRtbCampaignSetupFlowPageModel(
      this.order,
      this.addonFeatureManager,
      this.l1Object
    );
    const initCampaign = await campaignCreateModel.getCampaign();
    campaignCreateModel.campaign = {
      basic: {
        ...initCampaign.basic,
        adType: this.campaigns[0].adType,
        ageMax: 65,
        ageMin: 18,
        messages: '',
        bidStrategy: BidStrategy.LOWEST_COST_WITHOUT_CAP,
        bindings: []
      },
      limitations: initCampaign.limitations
    };
    campaignCreateModel.createCampaignFormModels();
    await campaignCreateModel.setUpCampaignBasicFormModel(
      this.campaigns[0].adType,
      this.campaigns[0].adTypeId,
      false
    );
    const campaignBasicFormModel = campaignCreateModel.campaignBasicFormModel;
    const trackingConfig = campaignBasicFormModel?.trackingConfig;
    if (!trackingConfig) {
      throw new Error('Failed to create campaign tracking config');
    }

    const needShowConversionTracking = this.addonFeatureManager.isFeatureEnable(
      ADDONFEATURE.CONVERSION_TRACKING.CONV_TRACKING_LIST
    );

    const modifyTrackingState = new ModifyTrackingState(
      this.l1Object,
      needShowConversionTracking,
      this.campaigns,
      trackingConfig,
      getContextData
    );
    const trackingSummaryState = new TrackingSummaryState(
      this.campaigns,
      trackingConfig,
      getContextData
    );
    modifyTrackingState.setNextFn(() => goModalStateFn(trackingSummaryState));
    modifyTrackingState.setCloseFn(closeModalFn);
    trackingSummaryState.setBackFn(() => goModalStateFn(modifyTrackingState));
    trackingSummaryState.setCloseFn(closeModalFn);
    return modifyTrackingState;
  }
}
